import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from '../../forms/FormField';
import { Button } from 'react-bootstrap';

const required = value => value ? undefined : 'Required';
const validEmail = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Enter a vaild email address'
    : undefined;

const ResetYourPasswordForm = props => {
  const { handleSubmit, submitting } = props;
  return (
    <form onSubmit={handleSubmit}>
      <h2>Reset your password</h2>
      <p className="help">
        Enter your email address and we'll send you a link to reset your password.
      </p>
      <Field
        name="username"
        type="text"
        component={FormField.Input}
        label="Email"
        validate={[required, validEmail]}
        insetLabel
        icon="envelope"
      />
      <div>
        <Button className="btn btn-primary" type="submit">
          Reset password
        </Button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'reset-password'
})(ResetYourPasswordForm);
